/**
 * @generated SignedSource<<51a72fdb64872a1d64ec1bf922123b10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_deliveryOptions$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_deliveryOptions">;
  readonly " $fragmentType": "CheckoutLayout_deliveryOptions";
}>;
export type CheckoutLayout_deliveryOptions$key = ReadonlyArray<{
  readonly " $data"?: CheckoutLayout_deliveryOptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_deliveryOptions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CheckoutLayout_deliveryOptions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_deliveryOptions"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};

(node as any).hash = "ae4be5572a150471eef2573806aa347d";

export default node;
